import IntroductionQuestions from '@/content/faqs/answers/signup/introduction.json';

export default class FaqIntroductions {
    /**
     * Get the introduction questions.
     *
     * @return {Promise}
     */
    handle() {
        return new Promise((resolve) => resolve(IntroductionQuestions.items));
    }
}
